module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_3-80930cfdde6b8da378dd0dff2b273e93.jpg";